import { AspectRatio, Box, Button, Flex, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

export const VideoSection = () => {
  const { t } = useTranslation();

  return (
    <Box bgColor="gray.900" p={14} textAlign="center">
      <Flex color="white" flexDirection="column" alignItems="center" maxW="800px" margin="auto">
        <AspectRatio width={{ base: '340px', sm: '490px' }} ratio={16 / 9}>
          <iframe
            src="https://player.vimeo.com/video/811138682"
            allow="fullscreen; picture-in-picture"
            title="Underline White Glove Service Demo"
          />
        </AspectRatio>
        <Text mt={12} fontSize="3xl" fontFamily="heading" fontWeight="bold">
          {t('whiteGloveServicePage.videoHeading')}
        </Text>
        <Text mt={4}>{t('whiteGloveServicePage.videoDescription')}</Text>
        <Button
          as={NextLink}
          href="/contact-us/conferences"
          variant="solid"
          alignSelf="center"
          mt={12}
          rightIcon={<ArrowIcon />}
        >
          {t('newEventPage.getStarted')}
        </Button>
      </Flex>
    </Box>
  );
};
